import React, { useState } from "react";
import { Swords } from "lucide-react";

/** Direct CDN URLs for each league logo (same CDN as team logos). */
export const LEAGUE_LOGOS = {
  NBA:   "https://media.api-sports.io/basketball/leagues/12.png",
  NCAAB: "https://media.api-sports.io/basketball/leagues/116.png",
  NFL:   "https://media.api-sports.io/american-football/leagues/1.png",
  NCAAF: "https://media.api-sports.io/american-football/leagues/2.png",
  NHL:   "https://media.api-sports.io/hockey/leagues/57.png",
  MLB:   "https://media.api-sports.io/baseball/leagues/1.png",
  EPL:   "https://media.api-sports.io/football/leagues/39.png",
  MMA:   null, // no clean single-league logo for MMA
};

/**
 * League logo — icon-only variant with graceful fallback.
 * `size` = pixel height (width auto).
 */
export const LeagueLogo = ({ code, size = 20, className = "" }) => {
  const [failed, setFailed] = useState(false);
  const src = LEAGUE_LOGOS[code];
  const px = `${size}px`;

  if (!src || failed) {
    // MMA or fallback -> stylized icon
    return (
      <span
        className={`flex items-center justify-center rounded-md bg-primary text-primary-foreground ${className}`}
        style={{ width: px, height: px, fontSize: size <= 20 ? 8 : 10 }}
        aria-label={code}
      >
        {code === "MMA" ? <Swords className="size-3" /> : (code || "?").slice(0, 3)}
      </span>
    );
  }
  return (
    <span
      className={`inline-flex shrink-0 items-center justify-center overflow-hidden rounded-md bg-white ${className}`}
      style={{ width: px, height: px }}
    >
      <img
        src={src}
        alt={code}
        onError={() => setFailed(true)}
        draggable={false}
        className="max-h-full max-w-full object-contain"
        style={{ padding: 1 }}
      />
    </span>
  );
};

/**
 * Chip combining logo + code text (used everywhere a league badge is shown).
 */
export const LeagueChip = ({ code, className = "", compact = false, testid }) => (
  <span
    className={`inline-flex items-center gap-1.5 rounded-full border border-border bg-gray-50 py-0.5 pl-0.5 pr-2 text-[11px] font-semibold text-gray-700 ${className}`}
    data-testid={testid ?? `league-chip-${code}`}
  >
    <LeagueLogo code={code} size={18} />
    {!compact && code}
  </span>
);
